import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {VitalSignItem, VitalSignRecord, VitalSignType} from '@shared/models/vital-sign.model';

@Injectable({
  providedIn: 'root'
})
export class VitalSignService {

  constructor(private http: HttpClient) {
  }

  getVitalSignsHttp(page: number, size: number): Promise<HttpResponse<VitalSignRecord[]>> {
    const url = '/api/v1/vital/signs/records';
    let httpParams = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    return this.http.get<VitalSignRecord[]>(url, {params: httpParams, observe: 'response'}).toPromise();
  }

  getVitalSignItems(page: number, size: number, vitalSignType: string): Promise<VitalSignItem[]> {
    const url = '/api/v1/vital/signs/graph';
    let httpParams = new HttpParams()
      .set('size', size.toString())
      .set('page', page.toString())
      .set('type', vitalSignType.toString());

    return this.http.get<VitalSignItem[]>(url, {params: httpParams}).toPromise();
  }

  getVitalSignTypes(): Promise<VitalSignType[]> {
    const url = '/api/v1/vital/signs/types';
    return this.http.get<VitalSignType[]>(url).toPromise();
  }

  createVitalSignRecord(model: VitalSignRecord): Promise<void> {
    const url = `/api/v1/vital/signs/records`;
    return this.http.post<void>(url, model).toPromise();
  }

  getVitalSignRecord(recordId: number): Promise<VitalSignRecord> {
    const url = `/api/v1/vital/signs/records/${recordId}`;
    return this.http.get<VitalSignRecord>(url).toPromise();
  }

  updateVitalSignRecord(model: VitalSignRecord): Promise<VitalSignRecord> {
    const url = `/api/v1/vital/signs/records`;
    return this.http.put<VitalSignRecord>(url, model).toPromise();
  }

  deleteVitalSignRecord(recordId: number): Promise<void> {
    const url = `/api/v1/vital/signs/records/${recordId}`;
    return this.http.delete<void>(url).toPromise();
  }
}
